module.exports = __webpack_public_path__ + "static/media/ev-5.1a5230d8.jpg";